export default "__VITE_PUBLIC_ASSET__2c6b9ea8__"